import React from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import EmptyState from '../EmptyState';

const StateContainer = ({
  isLoading = false,
  isError = false,
  errorMessage = 'An unexpected error occurred while fetching data.',
  isEmpty = false,
  emptyTitle,
  emptyDescription,
  onRetry,
  children
}) => {
  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="300px"
        width="100%"
      >
        <CircularProgress size={60} thickness={4} sx={{ color: 'rgba(255, 255, 255, 0.7)' }} />
      </Box>
    );
  }

  if (isError) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        py={8}
        px={3}
        textAlign="center"
        sx={{ minHeight: '300px' }}
      >
        <Box
          sx={{
            backgroundColor: 'rgba(244, 67, 54, 0.1)',
            borderRadius: '50%',
            p: 3,
            mb: 3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 64, color: '#f44336' }} />
        </Box>
        <Typography variant="h6" sx={{ color: '#fff', fontWeight: 600, mb: 1 }}>
          Something went wrong
        </Typography>
        <Typography variant="body2" sx={{ color: '#8b8fa8', mb: 3, maxWidth: '400px' }}>
          {errorMessage}
        </Typography>
        {onRetry && (
          <Button variant="contained" color="primary" onClick={onRetry} sx={{ textTransform: 'none' }}>
            Try Again
          </Button>
        )}
      </Box>
    );
  }

  if (isEmpty) {
    return (
      <EmptyState
        title={emptyTitle}
        description={emptyDescription}
      />
    );
  }

  return <>{children}</>;
};

export default StateContainer;
